module.exports = __webpack_public_path__ + "assets/img/img-placeholder-reel-w1140.62e92d70.webp";